import React, { Component } from "react";
import {
  withStyles,
  Grid,
  Box,
  Checkbox,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";

import clsx from "clsx";
import AssistantsDetails from "./AssistantsDetails";
import { withRouter } from "react-router-dom";
import {
  scrollKey,
  trackScroll,
  saveScroll,
  restoreScroll,
} from "../../helpers/scrollRestore";
import { connect } from "react-redux";
import { Skeleton } from "@material-ui/lab";

export const fields = [
  {
    name: "WhatsApp Number",
    size: 12,
    key: "whatsappNumber",
  },
  {
    name: "FBM id",
    size: 12,
    key: "fbBusinessId",
  },
  {
    name: "Waba id",
    size: 12,
    key: "wabaAppId",
  },
  {
    name: "Display Name",
    size: 12,
    key: "assistantName",
  },
  {
    name: "Waba Live Date",
    size: 12,
    key: "firstPaidPlanStartedOn",
  },
  {
    name: "MM Lite",
    size: 12,
    key: "mmLiteConfig",
  },
  {
    name: "WA Business App Users(Coexistence)",
    size: 12,
    key: "coexistence",
  },
  {
    name: "Current Plan Started On",
    size: 12,
    key: "planActivatedOn",
  },
  {
    name: "Current Plan Renewal Date",
    size: 12,
    key: "planRenewalOn",
  },
  {
    name: "Plan Stop Date",
    size: 12,
    key: "planStoppedOn",
  },
  {
    name: "Waba Disabled Date",
    size: 12,
    key: "wabaAppStatus",
  },
  {
    name: "Client Name",
    size: 12,
    key: "clientId",
  },
  {
    name: "FB Manager Status",
    size: 12,
    key: "fbManagerVerified",
  },
  {
    name: "Display Name Status",
    size: 12,
    key: "displayNameVerified",
  },
  {
    name: "Quality Rating",
    size: 12,
    key: "qualityRating",
  },
  {
    name: "WCC Credit",
    size: 12,
    key: "templateCredit",
  },
  {
    name: "Created At",
    size: 12,
    key: "createdAt",
  },
  {
    name: "Messaging Limit",
    size: 12,
    key: "dailyTemplateLimit",
  },

  {
    name: "Project Status",
    size: 12,
    key: "status",
  },
  {
    name: "WABA Status",
    size: 12,
    key: "wabaStatus",
  },
];

const quickFilters = [
  "Last active - 24 hr window",
  "Created - This week",
  "Created - This month",
];

class AssistantsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
      selectedTemplate: null,
    };
  }

  scroller = React.createRef();

  componentDidMount() {
    this.scrollKey = scrollKey(this.props.location);
    // history is a mutable singleton, so the action has to be read now: a later
    // navigation would flip it away from POP before a retry gets to run.
    this.navAction = this.props.history.action;
    this.restoreScroll();
  }
  componentDidUpdate() {
    // Tab and page changes rewrite the query string without remounting, so the
    // key has to follow the URL or the offset is filed under a stale one.
    const key = scrollKey(this.props.location);
    if (key !== this.scrollKey) {
      this.scrollKey = key;
      this.scrollRestored = true; // a different list starts at the top
    }
    this.restoreScroll();
  }
  componentWillUnmount() {
    saveScroll(this.scrollKey, this.scroller.current);
  }
  // Recorded as the user scrolls rather than only at teardown, so the offset
  // does not depend on what the DOM happens to look like when the table is
  // torn down.
  handleScroll = (event) => {
    trackScroll(this.scrollKey, event.currentTarget);
  };
  restoreScroll = () => {
    if (this.scrollRestored) return;
    this.scrollRestored = restoreScroll(
      this.scrollKey,
      this.scroller.current,
      this.navAction
    );
  };
  listScrolled = (event) => {
    if (!this.offsetPosition) {
      this.offsetPosition = this.rootEle.current.offsetTop;
    }
    const container = event.currentTarget;
    const currentPos = container.scrollTop;
    this.setState({
      sticky: currentPos > this.offsetPosition,
    });
  };
  toggleDialog = () => {
    this.setState({ openDialog: !this.state.openDialog });
  };
  openTemplate = (e) => {
    const templates = [...this.props.templates];
    const foundIndex = templates.findIndex((x) => x._id == e._id);
    this.props.history.push("/assistants/" + templates[foundIndex]._id);
    // this.setState({ openDialog: true, selectedTemplate: foundIndex });
  };
  render() {
    const { classes, templates } = this.props;
    return (
      <>
        <div
          ref={this.scroller}
          onScroll={this.handleScroll}
          className={classes.root}
        >
          <Grid container>
            <Grid container item xs={12} md={12} lg={12}>
              <Grid container>
                <Box
                  className={classes.tableWrapper}
                  mb={{ xs: 2, md: 4 }}
                  mx={{ xs: 2, md: 0 }}
                >
                  <Grid item container className={classes.tableContainer}>
                    <Grid
                      item
                      xs={12}
                      container
                      className={classes.tableHeader}
                    >
                      {fields.map((e) => (
                        <Grid
                          item
                          xs={e.size}
                          key={e.key}
                          style={{
                            width: "20%",
                          }}
                        >
                          <Box py={2} pl={2}>
                            <Typography variant="h5" color="primary">
                              {e.name}
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                    {templates.map((e) => (
                      <Tooltip
                        title={e.partnerArchived ? "Project is archived" : ""}
                      >
                        <Grid
                          item
                          xs={12}
                          container
                          onScroll={this.listScrolled}
                          className={
                            !!e.partnerArchived
                              ? classes.tableItemNoHover
                              : classes.tableItem
                          }
                        >
                          {fields.map((field) => (
                            <Grid
                              item
                              xs={field.size}
                              style={{
                                width: "20%",
                                overflow: "hidden",
                              }}
                              onClick={
                                !!e.partnerArchived
                                  ? null
                                  : () => this.openTemplate(e)
                              }
                            >
                              <Cell
                                classes={classes}
                                item={e}
                                field={
                                  this.props.isLoading ? "Loading" : field.key
                                }
                                allBusiness={this.props.allBusiness}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Tooltip>
                    ))}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <Dialog
          open={this.state.openDialog}
          onClose={this.toggleDialog}
          aria-labelledby="form-dialog-title"
          fullScreen
        >
          {/* Assistants Details */}
          <AssistantsDetails
            templateIndex={this.state.selectedTemplate}
            templates={this.props.templates}
            toggleDialog={this.toggleDialog}
            setTemplate={this.props.setTemplate}
          />
        </Dialog>
      </>
    );
  }
}

function Cell({ classes, item, field, allBusiness, openCampaign, ...props }) {
  switch (field) {
    case "remainingCredit":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">{item[field] / 100000}</Typography>
          </Box>
        </Grid>
      );
      break;

    case "templateCredit":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item[field] ? item[field] / 100000 : 0}
            </Typography>
          </Box>
        </Grid>
      );
      break;

    case "assistantName":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item[field]?.startsWith("__archived__")
                ? item[field].replace("__archived__", "")
                : item[field]}
            </Typography>
          </Box>
        </Grid>
      );
      break;
    case "createdAt":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {getFormattedDate(item[field])}
            </Typography>
          </Box>
        </Grid>
      );

      break;
    case "clientId":
      return (
        <Box py={2} pl={2}>
          <Typography variant="body1" noWrap>
            {item[field] && allBusiness[item[field]]?.name}
            {/* {columnData[key]} */}
            {/* {agents.find((i) => i._id === columnData[key])?.displayName || "-"} */}
          </Typography>
        </Box>
      );
      break;
    case "Loading":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            {Array.from(Array(20).keys()).map((i) => {
              return (
                <div key={i} className={classes.tableItem1}>
                  <Skeleton className={classes.skeleton} />
                </div>
              );
            })}
          </Box>
        </Grid>
      );
      break;
    case "whatsappNumber":
      return (
        <Box py={2} pl={2}>
          <Typography variant="body1" noWrap>
            {item[field]
              ? item[field].startsWith("__archived__")
                ? item[field].replace("__archived__", "+")
                : "+" + item[field]
              : "-"}
          </Typography>
        </Box>
      );
      break;

      break;

    case "excessUsage":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">{item[field] / 100000}</Typography>
          </Box>
        </Grid>
      );
      break;
    case " company":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">{item[field] / 100}</Typography>
          </Box>
        </Grid>
      );
      break;
    case "wabaAppStatus":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item[field]?.waba_ban_date || "-"}
            </Typography>
          </Box>
        </Grid>
      );
    case "firstPaidPlanStartedOn":
    case "planActivatedOn":
    case "planRenewalOn":
    case "planStoppedOn":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item[field]
                ? new Date(item[field]).toLocaleDateString("en-GB")
                : "-"}
            </Typography>
          </Box>
        </Grid>
      );
    case "mmLiteConfig":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item?.mmLiteConfig?.enabled ? "enabled" : "disabled"}
            </Typography>
          </Box>
        </Grid>
      );
    case "coexistence":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item?.specialAccess?.coexistence ||
              item?.coexistence?.activatedOn
                ? "enabled"
                : "disabled"}
            </Typography>
          </Box>
        </Grid>
      );
    case "qualityRating":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">{["Low", "FLAGGED", "RED"].includes(item[field])
              ? "LOW"
              : ["UNFLAGGED", "Medium", "RESTRICTED", "YELLOW"].includes(
                item[field]
              )
                ? "MEDIUM"
                : "HIGH"}</Typography>
          </Box>
        </Grid>
      );
    case "status":
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {item.partnerArchived
                ? "Archived"
                : item.status === "stopped"
                  ? "Stopped"
                  : "Active"}
            </Typography>
          </Box>
        </Grid>
      );
    case "wabaStatus": {
      const isWabaBanned = ["DISABLE", "SCHEDULE_FOR_DISABLE"].includes(
        item.wabaAppStatus?.waba_ban_state
      );
      const isFullyOnboarded =
        item.isWhatsappVerified === true &&
        item.wabaProgressStep === 9 &&
        !item.partnerArchived;
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">
              {isFullyOnboarded
                ? isWabaBanned
                  ? "Disabled"
                  : "Live"
                : item.wabaDeleted
                  ? "Deleted"
                  : "Draft"}
            </Typography>
          </Box>
        </Grid>
      );
    }
    default:
      return (
        <Grid item xs>
          <Box py={2} pl={2}>
            <Typography variant="h5">{item[field]}</Typography>
          </Box>
        </Grid>
      );
  }
}

export function getFormattedDate(date) {
  const d = new Date(date);
  const options = { year: "numeric", month: "long", day: "numeric" };
  return d.toLocaleDateString("en-US", options);
}
const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    // background: "red",
    // display: "flex",
    background: "rgb(249,249,249)",
    boxSizing: "border-box",
    overflowX: "hidden",
    position: "relative",
    // marginBottom: "5em",
    // paddingBottom: "80px"
  },
  tableWrapper: {
    overflowX: "auto",
    width: "100%",
  },

  tableContainer: {
    marginTop: "1.5em",
    minWidth: 2400,
  },

  tableItem: {
    background: "white",
    marginBottom: "1em",
    padding: 4,
    flexWrap: "nowrap",
    borderRadius: 8,
    cursor: "pointer",
    "&:hover": {
      background: "#efefef",
    },
  },
  tableItemNoHover: {
    background: "white",
    marginBottom: "1em",
    padding: 4,
    flexWrap: "nowrap",
    borderRadius: 8,
  },
  tableItem1: {
    marginBottom: "1em",
    padding: 4,
    flexWrap: "nowrap",
    borderRadius: 8,
  },

  tableHeader: {
    background: "white",
    padding: 4,
    borderRadius: 8,
    marginBottom: "1em",
    flexWrap: "nowrap",
  },
  row: {
    background: "white",
    display: "flex",
  },
  alterRow: {
    background: "rgb(246,246,246)",
  },
  dataRow: {
    cursor: "pointer",
    transition: "0.3s",
    "&:hover": {
      background: "rgb(70 20 134 / 15%)",
    },
  },
  topbar: {
    background: "rgb(252,252,252)",
    position: "sticky",
    top: "0",
    zIndex: "100",
  },
  column: {
    // width: "4400px",
    fontWeight: "normal",
    height: "50px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    boxSizing: "border-box",
  },
});

// export default withStyles(styles)(withRouter(AssistantsTable));

const connectAssistantsTable = connect((state) => ({
  allBusiness: state.business.allBusiness,
  isLoading: state.assistants.isLoading,
}))(AssistantsTable);

export default withStyles(styles)(withRouter(connectAssistantsTable));
